import React from 'react';
import Document from "../common/Document";
import { DocumentType } from "../../enums/DocumentType";
import { MannerOfDeath } from "../../enums/MannerOfDeath";
import { useFormikContext } from "formik";
import { LifeBeneficiaryFormValues } from "../../life/LifeBeneficiaryFormValues";

const BeneficiaryDocument = () => {
    const { values } = useFormikContext<LifeBeneficiaryFormValues>();
    const isAccident = values.mannerOfDeath === MannerOfDeath.ACCIDENT;
    let documentDescription;
    let documentTypeOptions = [
        DocumentType.DEATH_CERTIFICATE
    ];
    if (isAccident) {
        const accidentDocumentTypeOptions = [
            DocumentType.INCIDENT,
            DocumentType.AUTOPSY,
            DocumentType.NEWSPAPER,
            DocumentType.POLICE_DEPARTMENT_INFO,
            DocumentType.TRANSPORTATION_BILL,
            DocumentType.HIPAA_AUTH
        ]
        documentTypeOptions = documentTypeOptions.concat(accidentDocumentTypeOptions)
        documentDescription = <div className="flex-gap">
            <div>
                If accidental death/personal loss benefits are being claimed, in addition to the death certificate, one or more of the following may be needed:
            </div>
            <ul>
                {accidentDocumentTypeOptions.map(d => (
                    <li>{d}</li>
                ))}
            </ul>
            <div>
                For a transportation bill, please upload the bill showing the incurred cost for preparation and transportation of the body if the death occurs more than 100 miles from permanent residence.
            </div>
        </div>
    }

    return (
        <Document documentTypeOptions={documentTypeOptions} documentDescription={documentDescription}/>
    )
};

export default BeneficiaryDocument;